import i18n from "i18next"

// Returns the PT fallback when i18next is not initialised (node unit tests run without it).
export function tr(key: string, fallback: string, options?: Record<string, unknown>): string {
  if (!i18n.isInitialized) return fallback
  return (i18n.t as unknown as (k: string, o?: Record<string, unknown>) => string)(key, options)
}
